// extracted by mini-css-extract-plugin
export default {"InfoBoxContainer":"_InfoBoxContainer--bZlAS","Link":"_Link--By8Wz"};